// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Kg8cp","name":"Header_name__1GjC3","birthday":"Header_birthday__1vYlA","skeleton":"Header_skeleton__2_JiK"};